import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import DeleteIcon from '@mui/icons-material/Delete'
import {pink} from '@mui/material/colors'
import StyleIcon from '@mui/icons-material/Style'

interface DeleteDialogProps {
  open: boolean
  title: string
  message: string
  handleCloseCancel: () => void
  handleCloseDelete: () => void
}

export default function DeleteDialog(props: DeleteDialogProps) {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleCloseCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {props.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined'  
                sx={{
          color: "white",
          display: "flex",
          fontSize: '16px',
          textTransform: 'none',
        }}onClick={props.handleCloseCancel} autoFocus>Cancel</Button>
        <Button color='error'
                startIcon={<DeleteIcon sx={{ color: pink[600]}}/> } variant='outlined' 
                sx={{
          color: "white",
          display: "flex",
          fontSize: '16px',
          textTransform: 'none',
        }}
                onClick={props.handleCloseDelete}>Delete</Button>
      </DialogActions>
    </Dialog>
  )
}
